'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _baseState = require('./baseState');

var _baseState2 = _interopRequireDefault(_baseState);

var _tuner = require('../tuner');

var _tuner2 = _interopRequireDefault(_tuner);

var _listenTime = require('../loggers/listenTime');

var _listenTime2 = _interopRequireDefault(_listenTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var maxWaitTime = 15000;
var currentTune = void 0;
var waitTimeout = void 0;
var bufferStartTime = void 0;
var wasPlaying = false;

function clearWaitTimeout() {
  if (waitTimeout) {
    clearTimeout(waitTimeout);
    waitTimeout = undefined;
  }
}

function transitionToPlayingState() {
  var sendBufferReportOnPlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  clearWaitTimeout();
  var context = { continueCurrentLogger: true };

  if (sendBufferReportOnPlay) {
    context.bufferStartTime = bufferStartTime;
  }

  _tuner2.default.changeState(_tuner2.default.states.playing, context);
}

function onPlay() {
  _listenTime2.default.logBuffer(currentTune, bufferStartTime);
  transitionToPlayingState();
}

function onBuffer() {
  transitionToPlayingState(true);
}

function onWaitTimeout() {
  _listenTime2.default.logFailure(currentTune);

  _tuner2.default.trigger(_tuner2.default.events.error, {
    message: 'Stream timeout',
    context: {
      streamId: _tuner2.default.streamPlayer.getCurrentStreamId()
    }
  });

  _tuner2.default.changeState(_tuner2.default.states.connecting, { wasPlaying: wasPlaying });
}

var state = {
  name: 'waiting',
  enter: function enter(previousState) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    currentTune = context.currentTune;
    wasPlaying = context.wasPlaying || false;
    bufferStartTime = Date.now();
    _tuner2.default.trigger(_tuner2.default.events.waiting);

    _tuner2.default.streamPlayer.on(_tuner2.default.streamPlayer.events.play, onPlay);
    _tuner2.default.streamPlayer.on(_tuner2.default.streamPlayer.events.buffer, onBuffer);

    waitTimeout = setTimeout(onWaitTimeout, maxWaitTime);
  },
  exit: function exit() {
    clearWaitTimeout();
    bufferStartTime = 0;
    wasPlaying = false;
    _tuner2.default.streamPlayer.remove(_tuner2.default.streamPlayer.events.play, onPlay);
    _tuner2.default.streamPlayer.remove(_tuner2.default.streamPlayer.events.buffer, onBuffer);
  }
};

module.exports = (0, _extends3.default)({}, _baseState2.default, state);
//# sourceMappingURL=waiting.js.map